import { Text, View } from "@react-pdf/renderer";
import { styles } from "../GenericPdf/style";
import { SinglePdfHeaderType } from "../GenericPdf/constant";
import {
  handleGstSummaryWidth,
} from "../CommonPdfComponents/utils";

type AppProps = {
  items: any;
  tableHeaders: SinglePdfHeaderType[];
};

const GstSummaryTableRow = ({ items, tableHeaders }: AppProps) => {
  const handleRows = () => {
    const finalItems = items?.map((item: any, index: number) => {
      return (
        <View key={index} style={styles.row}>
          {tableHeaders?.map(
            (header: SinglePdfHeaderType, subIndex: number) => {
              return (
                <Text
                  key={`${index}+"."+${subIndex}`}
                  style={{
                    ...styles.table_width,
                    paddingRight:
                      header.column_value === "sku_code" ? "35px" : "30px",
                    paddingLeft: "1px",
                    width: handleGstSummaryWidth(tableHeaders?.length),
                    ...styles.currencyFont,
                    paddingBottom: 1,
                    fontSize: "8px",
                  }}
                >
                   {((header?.name === "GST Summary" || !item?.[header?.column_value])  ? item?.[header?.column_value] : item?.[header?.column_value]?.toFixed(2) ) + (header?.name === "GST Summary" ? "%" : "")}
                </Text>
              );
            }
          )}
        </View>
      );
    });

    return finalItems;
  };

  return <View>{handleRows()}</View>;
};

export default GstSummaryTableRow;
